import { Injectable, EventEmitter, ElementRef } from '@angular/core';
import { HttpClientModule, HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { Observer } from 'rxjs';
import { connect, createLocalTracks, createLocalVideoTrack } from 'twilio-video';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Injectable({
  providedIn: 'root'
})
export class TwilioService {

  previewing: boolean;
  msgSubject = new BehaviorSubject("");

  constructor(private http: HttpClient) {}


  connectToRoom(accessToken: string, options, localVideo, remoteVideo, roomObj): void {

    console.log(`Attempting to connect to room ${options.name} with token ${accessToken}`);

    connect(accessToken, options).then(room => {

      roomObj = room;

      if (options['video']) {
        this.startLocalVideo(localVideo);
        //this.previewing = true;
      }

      room.participants.forEach(participant => {
        this.msgSubject.next("Already in Room: '" + participant.identity + "'");
        // console.log("Already in Room: '" + participant.identity + "'");
        // this.attachParticipantTracks(participant);
      });

      room.on('participantDisconnected', (participant) => {
        this.msgSubject.next(participant.identity + "' left");
        // console.log("Participant '" + participant.identity + "' disconnected");

        this.detachParticipantTracks(participant);
      });

      room.on('participantConnected',  (participant) => {

        this.msgSubject.next(participant.identity + " connected");

        console.log(participant);


        participant.tracks.forEach(track => {
          remoteVideo.nativeElement.appendChild(track.attach());
        });

        // participant.on('trackAdded', track => {
        //   console.log('track added')
        //   this.remoteVideo.nativeElement.appendChild(track.attach());
        //   // document.getElementById('remote-media-div').appendChild(track.attach());
        // });
      });

      // When a Participant adds a Track, attach it to the DOM.
      room.on('trackAdded', (track, participant) => {
        console.log(participant.identity + " added track: " + track.kind);
        this.attachTracks([track], remoteVideo);
      });

      // When a Participant removes a Track, detach it from the DOM.
      room.on('trackRemoved', (track, participant) => {
        console.log(participant.identity + " removed track: " + track.kind);
        this.detachTracks([track]);
      });

      room.once('disconnected',  room => {
        this.msgSubject.next('You left the Room:' + room.name);
        room.localParticipant.tracks.forEach(track => {
          var attachedElements = track.detach();
          attachedElements.forEach(element => element.remove());
        });
      });
    });
  }

  attachParticipantTracks(participant): void {
    var tracks = Array.from(participant.tracks.values());
    this.attachTracks([tracks], {});
  }

  attachTracks(tracks, remoteVideo) {
    tracks.forEach(track => {
      remoteVideo.nativeElement.appendChild(track.attach());
    });
  }

  startLocalVideo(localVideo): void {
    createLocalVideoTrack().then(track => {
      localVideo.nativeElement.appendChild(track.attach());
    });
  }

  localPreview(localVideo): void {
    createLocalVideoTrack().then(track => {
      localVideo.nativeElement.appendChild(track.attach());
    });
  }

  detachParticipantTracks(participant) {
    var tracks = Array.from(participant.tracks.values());
    this.detachTracks(tracks);
  }

  detachTracks(tracks): void {
    tracks.forEach(function (track) {
      track.detach().forEach(function (detachedElement) {
        detachedElement.remove();
      });
    });
  }

}
